import { useState } from "react";
import { useTranslation } from "react-i18next";
// Components
import {
  SessionMainDiv,
  SessionDiv,
  InfoDiv,
  SessionText,
  ShowExtraInfoButton,
  ShowExtraInfoImg,
  ExtraInfoDiv,
  ExtraInfoSessionDiv,
  ExtraInfoSessionTitle,
} from "./styles";
// Assets
import IcoArrowUp from "../../../assets/icons/ico_arrow_up.svg";
import IcoArrowDown from "../../../assets/icons/ico_arrow_down.svg";

const SessionData = ({ sessionNumber, date, hour, software, protocolTitle, score }) => {
  const [showExtraInfo, setShowExtraInfo] = useState(false);
  const [t] = useTranslation("global");

  const handleShowExtraInfo = (e) => {
    e.preventDefault();
    setShowExtraInfo(!showExtraInfo);
  };

  return (
    <SessionMainDiv>
      <SessionDiv>
        <InfoDiv>
          <SessionText width="100px" width910="75px">
            {sessionNumber}
          </SessionText>
          <SessionText width="138px" width910="80px">
            {date}
          </SessionText>
          <SessionText width="108px" width910="80px">
            {hour}
          </SessionText>
          <ShowExtraInfoButton onClick={handleShowExtraInfo}>
            <ShowExtraInfoImg src={showExtraInfo ? IcoArrowUp : IcoArrowDown} alt="ico-arrow" />
          </ShowExtraInfoButton>
        </InfoDiv>
        <ExtraInfoDiv show={showExtraInfo}>
          <ExtraInfoSessionDiv>
            <ExtraInfoSessionTitle>{t("application").toUpperCase()}</ExtraInfoSessionTitle>
            <SessionText width="144px" width910="auto">
              {software}
            </SessionText>
          </ExtraInfoSessionDiv>
          <ExtraInfoSessionDiv>
            <ExtraInfoSessionTitle>{t("activity").toUpperCase()}</ExtraInfoSessionTitle>
            <SessionText width="106px" width910="auto">
              {protocolTitle}
            </SessionText>
          </ExtraInfoSessionDiv>
          <ExtraInfoSessionDiv>
            <ExtraInfoSessionTitle>{t("score").toUpperCase()}</ExtraInfoSessionTitle>
            <SessionText width="90px" width910="auto">
              {score}
            </SessionText>
          </ExtraInfoSessionDiv>
        </ExtraInfoDiv>
      </SessionDiv>
    </SessionMainDiv>
  );
};

export default SessionData;
